import { LegalPageLayout } from '@/components/layout/LegalPageLayout';
import { PrivacyPolicyContent } from '@/components/legal/PrivacyPolicyContent';

export const PrivacyPolicyPage = () => {
  return (
    <LegalPageLayout
      title="Privacy Policy"
      lastUpdated="December 27, 2025"
    >
      <PrivacyPolicyContent />
    </LegalPageLayout>
  );
};
